import {
  ArrowUpOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileOutlined,
  FrownOutlined,
  LoadingOutlined,
  MehOutlined,
  MoreOutlined,
  SmileOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  BackTop,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Empty,
  Image,
  Input,
  Menu,
  message,
  Modal,
  notification,
  Popconfirm,
  Rate,
  Row,
  Select,
  Spin,
  Switch,
  Tabs,
  Tag,
  Tooltip,
  Upload,
} from "antd";
import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { generateToken } from "../../auth/auth";
import { axiosInstance } from "../../commons/commons";
import { decodedToken, encodedToken } from "../../constants/constants";
import {
  attachment,
  baseUrl,
  complaint,
  complaintType,
  documentAttachment,
  unitHandoverVacating,
  vwRentalTcList,
} from "../../constants/url";
const complaintURL = complaint;

class TenantHome extends React.Component {
  state = {
    dataIsLoading: true,
    complaintData: { list: [] },
    contractData: { list: [] },
    buildingData: { list: [] },
    unitData: { list: [] },
    complaintTypeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    chequeData: { list: [] },
    mode: "All",
    dataBeingSaved: false,
    modalIsVisible: false,
    moveoutModalIsVisible: false,
    complaint: {
      ComplaintDate: moment(),
      LegalCompany_ID: decodedToken.value.LegalCompany_ID,
      ProjectID: decodedToken.value.ProjectID,
      Division_ID: decodedToken.value.Division_ID,
      BuildingID: decodedToken.value.BuildingID,
      UnitID: decodedToken.value.UnitID,
      OpenClosed: "Open",
      ComplaintTypeID: null,
      Remarks: "",
      TenantFeedback: "",
      FeedbackPoints: 0,
      Feedback: "",
      SolutionDescription: "",
      TCID: null,
      EnteredBy: decodedToken.value.TenantID,
      Entered_Party_Type: "T",
      ComplaintDetails: [{}],
      ComplaintManpowers: [],
      ComplaintMaterials: [],
      ComplaintAttachments: [],
    },
    feedbackRate: {
      customIcons: {
        1: <FrownOutlined />,
        2: <FrownOutlined />,
        3: <MehOutlined />,
        4: <SmileOutlined />,
        5: <SmileOutlined />,
      },
      list: ["Poor", "Fair", "Average", "Good", "Excellent"],
    },
    handoverVacating: { TCID: null, VacatingDate: moment(), RentalTCUnits: [] },
    dateFormat: "YYYY-MM-DD",
    timeFormat: "HH:mm",
    attachmentList: [], // list of files that has been selected to upload
  };

  pdc_status_map = {
    R: "Received In Hand",
    P: "Submitted to bank",
    C: "Cleared",
    B: "Bounced",
    D: "Returned To Party",
    Y: "Other Cheque(s) Received Against",
    Z: "Cancelled TC's Cheques",
    H: "Put On Hold",
  };

  getInitialState = async () => {
    let state = {
      dataIsLoading: false,
      complaintData: { list: [] },
      contractData: { list: [] },
      buildingData: { list: [] },
      unitData: { list: [] },
      complaintTypeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      chequeData: { list: [] },
      mode: "All",
      dataBeingSaved: false,
      modalIsVisible: false,
      moveoutModalIsVisible: false,
      complaint: {
        ComplaintDate: moment(),
        LegalCompany_ID: decodedToken.value.LegalCompany_ID,
        ProjectID: decodedToken.value.ProjectID,
        Division_ID: decodedToken.value.Division_ID,
        BuildingID: decodedToken.value.BuildingID,
        UnitID: decodedToken.value.UnitID,
        OpenClosed: "Open",
        ComplaintTypeID: null,
        Remarks: "",
        TenantFeedback: "",
        FeedbackPoints: 0,
        Feedback: "",
        SolutionDescription: "",
        TCID: null,
        EnteredBy: decodedToken.value.TenantID,
        Entered_Party_Type: "T",
        ComplaintDetails: [{}],
        ComplaintManpowers: [],
        ComplaintMaterials: [],
        ComplaintAttachments: [],
      },
      feedbackRate: {
        customIcons: {
          1: <FrownOutlined />,
          2: <FrownOutlined />,
          3: <MehOutlined />,
          4: <SmileOutlined />,
          5: <SmileOutlined />,
        },
        list: ["Poor", "Fair", "Average", "Good", "Excellent"],
      },
      handoverVacating: {
        TCID: null,
        VacatingDate: moment(),
        RentalTCUnits: [],
      },
      dateFormat: "YYYY-MM-DD",
      timeFormat: "HH:mm",
      attachmentList: [], // list of files that has been selected to upload
    };
    await axiosInstance
      .post(vwRentalTcList, {
        attributes: [
          "CompanyID",
          "LegalCompany_ID",
          "LegalcompanyName",
          "Division",
          "Division_ID",
          "ProjectID",
          "ProjectName",
          "BuildingID",
          "BuildingName",
          "UnitID",
          "UnitNo",
          "TenantEmail",
          "TenantContactNo",
        ],
        where: {
          TenantID: decodedToken.value.TenantID,
          TenantType: decodedToken.value.TenantType,
          // TCStatus: "Active",
        },
      })
      .then((res) => {
        if (res.data.success) {
          let buildingMap = {};
          let contractMap = {};
          res.data.message.map((contract, index) => {
            contract.key = index;
            contract.SN = index + 1;
            contract.TCDate = contract.TCDate.split("T")[0];
            contract.TCFromDate = contract.TCFromDate.split("T")[0];
            contract.TCToDate = contract.TCToDate.split("T")[0];
            (contract.RentalTCUnits || []).map((rtc) => {
              if (
                (rtc.Unit || {}).UnitNo &&
                (rtc.Unit.Building || {}).BuildingName
              ) {
                if (!buildingMap[rtc.Unit.Building.BuildingID])
                  buildingMap[rtc.Unit.Building.BuildingID] = {
                    BuildingID: rtc.Unit.Building.BuildingID,
                    BuildingName: rtc.Unit.Building.BuildingName,
                    LegalCompany_ID: contract.LegalCompany_ID,
                    Division_ID: contract.Division_ID,
                    ProjectID: contract.ProjectID,
                    units: [],
                  };
                buildingMap[rtc.Unit.Building.BuildingID].units.push({
                  UnitID: rtc.UnitID,
                  UnitNo: rtc.Unit.UnitNo,
                  TCID: contract.TCID,
                });
              }
              return rtc;
            });
            if (!contractMap[contract.TCID])
              contractMap[contract.TCID] = contract;
            return contract;
          });
          Object.keys(buildingMap).map((BuildingID) => {
            state.buildingData.list.push(buildingMap[BuildingID]);
            if (String(state.complaint.BuildingID) === String(BuildingID))
              state.unitData.list = buildingMap[BuildingID].units;
            return BuildingID;
          });
          Object.keys(contractMap).map((TCID) => {
            state.contractData.list.push(contractMap[TCID]);
            return TCID;
          });
        } else
          notification.error({
            message: "Fail",
            description: res.data.message || "Something went wrong!",
          });
      })
      .catch(() => {});
    await axiosInstance
      /**
       * query Entered_Party_Type=T meaning that
       * the complaints only registered by this
       * tenant will be retrieved.
       */
      .get(
        complaint +
          "?TCID=" +
          // "?Entered_Party_Type=T&TCID=" +
          state.contractData.list.map((contract) => contract.TCID).join(",")
      )
      .then((res) => {
        if (res.data.success)
          state.complaintData.list = res.data.message.rows.map(
            (complaint, index) => {
              complaint.key = index;
              complaint.SN = index + 1;
              complaint.ComplaintDate = complaint.ComplaintDate.split("T")[0];
              return complaint;
            }
          );
        else
          notification.error({
            message: "Fail",
            description: res.data.message || "Something went wrong!",
          });
      })
      .catch(() => {});
    await axiosInstance
      .get(complaintType)
      .then((res) => {
        if (res.data.success) state.complaintTypeData.list = res.data.message;
        state.complaintTypeData.list.map((type, index) => {
          if (
            type.UserName.toLowerCase().indexOf("general".toLowerCase()) !== -1
          ) {
            state.complaintTypeData.selectedIndex = index;
            state.complaintTypeData.selectedValue = type.UserName;
            state.complaintData.ComplaintDetails[0].ComplaintTypeID =
              type.ComplaintTypeID;
            state.complaintData.ComplaintTypeID = type.ComplaintTypeID;
          }
          return type;
        });
      })
      .catch(() => {});
    // await axiosInstance
    //   .get(cheque)
    //   .then((res) => {
    //     state.chequeData.list = res.data.message.map((chq, index) => {
    //       chq.V_DATE = chq.V_DATE ? chq.V_DATE.split("T")[0] : chq.V_DATE;
    //       chq.Chq_Ref_Dt = chq.Chq_Ref_Dt
    //         ? chq.Chq_Ref_Dt.split("T")[0]
    //         : chq.Chq_Ref_Dt;
    //       chq.Posted_Dt = chq.Posted_Dt
    //         ? chq.Posted_Dt.split("T")[0]
    //         : chq.Posted_Dt;
    //       return chq;
    //     });
    //   })
    //   .catch((err) => {});
    return state;
  };

  uploadAttachments = async (ComplaintID) => {
    if (this.state.attachmentList.length || !ComplaintID) {
      let formData = new FormData();
      this.state.attachmentList.map((attachment) =>
        formData.append("file", attachment)
      );
      return await axiosInstance // upload ComplaintAttachments
        .post(attachment + "/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (uploadResponse) => {
          if (uploadResponse && uploadResponse.data.success) {
            // notification.success({
            //   message: "Success",
            //   description: "Uploaded!",
            // });
            if (
              uploadResponse.data.message.location &&
              uploadResponse.data.message.location.length
            ) {
              let Doc_Name, Doc_Type, Doc_Ext;
              return await axiosInstance // populate attachment(s) info to database
                .post(documentAttachment + "/attachment", {
                  attachments: uploadResponse.data.message.location.map(
                    (filename) => {
                      Doc_Name = filename.split(".");
                      Doc_Ext = Doc_Name.pop();
                      Doc_Type = Doc_Ext.toUpperCase();
                      Doc_Name = Doc_Name.join(".");
                      return {
                        Doc_Name,
                        Doc_Ext,
                        Doc_Type,
                        PrimaryRefID: ComplaintID,
                        Ref_Type: 112,
                      };
                    }
                  ),
                })
                .then((attachmentResponse) => {
                  if (attachmentResponse && attachmentResponse.data.success) {
                    // notification.success({
                    //   message: "Success",
                    //   description: "Done!",
                    // });
                    this.setState({ attachmentList: [] });
                    return true;
                  } else return false;
                })
                .catch(() => {
                  return false;
                });
            } else return false;
          } else return false;
        })
        .catch(() => {
          return false;
        });
    }
  };

  deleteAttachment = (ID) => {
    axiosInstance
      .delete(documentAttachment + "/attachment/" + ID)
      .then((res) => {
        if (res.data.success) {
          notification.success({
            message: "Success",
            description: "Deleted!",
          });
          let state = this.state;
          state.complaint.ComplaintAttachments =
            state.complaint.ComplaintAttachments.filter(
              (attachment) => attachment.AutoNo !== ID
            );
          this.setState(state);
        } else
          notification.success({
            message: "Fail",
            description: "Couldnot delete due to unknown reason(s)!",
          });
      })
      .catch((err) => {
        notification.success({
          message: "Error",
          description: "Couldnot delete due to unknown reason(s)!",
        });
      });
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) => {
      if (this._isMounted) this.setState(st);
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          padding: "20px",
          paddingTop: "5px",
        }}
      >
        <Row>
          <Col span={10} xs={10} sm={8} md={8} lg={8}>
            <Row gutter={8}>
              <Col
                span={12}
                xs={8}
                sm={6}
                md={4}
                lg={4}
                style={{ textAlign: "left" }}
              >
                <h3>Filter</h3>
              </Col>
              <Col span={12} xs={16} sm={18} md={20} lg={20}>
                <Select
                  value={this.state.mode}
                  style={{ width: "100%", borderRadius: 20 }}
                  dropdownStyle={{
                    borderRadius: "10px",
                    MozBorderRadius: "10px",
                  }}
                  optionFilterProp="children"
                  onChange={(e) => this.setState({ mode: e })}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Select.Option key={0} value="All">
                    All
                  </Select.Option>
                  <Select.Option key={1} value="Contract">
                    Contract
                  </Select.Option>
                  <Select.Option key={2} value="Complaint">
                    Complaint
                  </Select.Option>
                  {/* <Select.Option key={3} value="Cheque">
                Cheque
              </Select.Option> */}
                </Select>
              </Col>
            </Row>
          </Col>
          <Col span={10} xs={4} sm={8} md={8} lg={8}></Col>
          <Col
            span={10}
            xs={10}
            sm={8}
            md={8}
            lg={8}
            style={{ textAlign: "right" }}
          >
            <Button
              style={{ borderRadius: 20 }}
              type="primary"
              onClick={() => {
                this.setState({
                  modalIsVisible: true,
                  complaint: {
                    ComplaintDate: moment(),
                    LegalCompany_ID: decodedToken.value.LegalCompany_ID,
                    ProjectID: decodedToken.value.ProjectID,
                    Division_ID: decodedToken.value.Division_ID,
                    BuildingID: decodedToken.value.BuildingID,
                    UnitID: decodedToken.value.UnitID,
                    OpenClosed: "Open",
                    ComplaintTypeID: null,
                    Remarks: "",
                    TenantFeedback: "",
                    FeedbackPoints: 0,
                    Feedback: "",
                    SolutionDescription: "",
                    TCID: null,
                    EnteredBy: decodedToken.value.TenantID,
                    Entered_Party_Type: "T",
                    ComplaintDetails: [{}],
                    ComplaintManpowers: [],
                    ComplaintMaterials: [],
                    ComplaintAttachments: [],
                  },
                });
              }}
            >
              New Complaint
            </Button>
          </Col>
        </Row>
        <Spin spinning={this.state.dataIsLoading} tip="fetching data...">
          {(this.state.mode === "All" || this.state.mode === "Complaint") &&
          this.state.complaintData.list.length ? (
            <Row>
              <Col span={24}>
                <Divider style={{ marginBottom: 0 }}>
                  <h3>Complaints</h3>
                </Divider>
              </Col>
            </Row>
          ) : null}
          <Row gutter={24}>
            {(this.state.mode === "All" || this.state.mode === "Complaint") &&
              this.state.complaintData.list
                .sort(
                  (a, b) =>
                    new Date(b.ComplaintDate) - new Date(a.ComplaintDate)
                )
                .map((complaint, i, arr) => {
                  return (
                    <Col
                      key={i}
                      span={4}
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 12 }}
                      lg={{ span: 8 }}
                      style={{
                        marginTop: 2,
                        // margin 0 for last item only
                        marginBottom: i === arr.length - 1 ? 0 : 18,
                      }}
                    >
                      <Card
                        key={i}
                        title={<span>{"#" + (i + 1)}</span>}
                        style={{
                          width: "100%",
                          // height: "100px",
                          borderRadius: "30px",
                        }}
                        headStyle={{
                          textAlign: "center",
                          height: "30px",
                          minHeight: "30px",
                          // border: "0px",
                        }}
                        bodyStyle={{
                          padding: 20,
                          borderBottom: "0px solid",
                        }}
                      >
                        <Row>
                          <Col span={24}>
                            <h3>
                              Status:{" "}
                              <Tag color="cyan" style={{ borderRadius: 25 }}>
                                {complaint.OpenClosed}
                              </Tag>
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>
                              Complaint No.:{" "}
                              <Popconfirm
                                title={
                                  <>
                                    <p>This ticket is marked as completed.</p>
                                    <p>Would you like to close it ?</p>
                                  </>
                                }
                                visible={
                                  false
                                  // (complaint.OpenClosed === "Open" &&
                                  //   (complaint.ComplaintStatus || {}).UserName ===
                                  //     "Completed") ||
                                  // (this.state.modalIsVisible ? false : undefined)
                                }
                                // defaultVisible={
                                //   complaint.OpenClosed === "Open" &&
                                //   (complaint.ComplaintStatus || {}).UserName ===
                                //     "Completed"
                                // }
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                  axiosInstance
                                    .put(complaintURL + "/updateMinors", {
                                      ComplaintID: complaint.ComplaintID,
                                      OpenClosed: "Closed",
                                    })
                                    .then((res) => {
                                      if (res.data.success) {
                                        message.success("Complaint closed !");
                                        let state = this.state;
                                        state.complaintData.list =
                                          state.complaintData.list.map(
                                            (comp) => {
                                              if (
                                                comp.ComplaintID ===
                                                complaint.ComplaintID
                                              ) {
                                                comp.OpenClosed = "Closed";
                                              }
                                              return comp;
                                            }
                                          );
                                        this.setState(state);
                                      }
                                    })
                                    .catch((err) => {});
                                }}
                              >
                                <Tag color="green" style={{ borderRadius: 25 }}>
                                  {complaint.ComplaintNo}
                                  {complaint.OpenClosed === "Closed" &&
                                  complaint.FeedbackPoints === 5 ? (
                                    ""
                                  ) : (
                                    <>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <EyeOutlined
                                        onClick={() => {
                                          axiosInstance
                                            .get(
                                              complaintURL +
                                                "?ComplaintID=" +
                                                complaint.ComplaintID
                                            )
                                            .then((res) => {
                                              if (!res.data.success)
                                                notification.error({
                                                  message: "Fail",
                                                  description:
                                                    res.data.message ||
                                                    "Couldnot load data!",
                                                });
                                              else {
                                                let state = this.state;
                                                state.complaint =
                                                  res.data.message.rows[0];
                                                if (
                                                  !state.complaint
                                                    .ComplaintDetails ||
                                                  !state.complaint
                                                    .ComplaintDetails.length
                                                )
                                                  state.complaint.ComplaintDetails =
                                                    [
                                                      {
                                                        ComplaintTypeID:
                                                          state.complaint
                                                            .ComplaintTypeID,
                                                        Description:
                                                          state.complaint
                                                            .Remarks,
                                                      },
                                                    ];
                                                state.complaint.ComplaintDate =
                                                  moment(
                                                    new Date(
                                                      complaint.ComplaintDate
                                                    )
                                                  );
                                                state.modalIsVisible = true;
                                                state.buildingData.list.map(
                                                  (building) => {
                                                    if (
                                                      state.complaint
                                                        .BuildingID ===
                                                      building.BuildingID
                                                    ) {
                                                      state.unitData.list =
                                                        building.units;
                                                    }
                                                    return building;
                                                  }
                                                );
                                                this.setState(state);
                                              }
                                            })
                                            .catch(() => {
                                              this.setState({
                                                dataIsLoading: false,
                                              });
                                            });
                                        }}
                                      />
                                    </>
                                  )}
                                </Tag>
                              </Popconfirm>
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>
                              Complaint Date:{" "}
                              {complaint.ComplaintDate.split("T")[0]}
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>
                              Building:{" "}
                              {(complaint.Building || {}).BuildingName || "N/A"}
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>
                              Unit: {(complaint.Unit || {}).UnitNo || "N/A"}
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>
                              Contract: {(complaint.TC || {}).TCNo || "N/A"}
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Description: {complaint.Remarks}</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={5}>
                            <h3>Satisfaction:</h3>
                          </Col>
                          <Col span={19}>
                            <div style={{ width: "100%", paddingLeft: 40 }}>
                              <Rate
                                disabled
                                style={{ width: "100%", color: "green" }}
                                tooltips={this.state.feedbackRate.list}
                                value={complaint.FeedbackPoints}
                                character={({ index }) =>
                                  this.state.feedbackRate.customIcons[index + 1]
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Remarks: {complaint.Feeback || "N/A"}</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24} style={{ textAlign: "center" }}></Col>
                        </Row>
                      </Card>
                    </Col>
                  );
                })}
          </Row>
          {(this.state.mode === "All" || this.state.mode === "Contract") &&
          this.state.contractData.list.length ? (
            <Row>
              <Col span={24}>
                <Divider style={{ marginBottom: 0 }}>
                  <h3>Contracts</h3>
                </Divider>
              </Col>
            </Row>
          ) : null}
          <Row gutter={24}>
            {(this.state.mode === "All" || this.state.mode === "Contract") &&
              this.state.contractData.list
                .sort((a, b) => new Date(b.TCDate) - new Date(a.TCDate))
                .map((contract, i, arr) => {
                  return (
                    <Col
                      key={i}
                      span={4}
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 12 }}
                      lg={{ span: 8 }}
                      style={{
                        marginTop: 2,
                        marginBottom: i === arr.length - 1 ? 0 : 18,
                      }}
                    >
                      <Card
                        key={i}
                        title={
                          <Row>
                            <Col span={8}></Col>
                            <Col span={8}>
                              <span>{"#" + (i + 1)}</span>
                            </Col>
                            <Col span={8} style={{ textAlign: "right" }}>
                              <Dropdown
                                overlay={
                                  <Menu>
                                    {/* <Popconfirm
                                      title="Are you sure?"
                                      onConfirm={() => {
                                        this.setState({
                                          moveoutModalIsVisible: contract.TCID,
                                        });
                                      }}
                                    > */}
                                    <Menu.Item disabled={contract.TCStatus!=='Active'}
                                      onClick={() => {
                                        this.setState({
                                          moveoutModalIsVisible: contract.TCID,
                                          handoverVacating: {
                                            ...this.state.handoverVacating,
                                            TCID: contract.TCID,
                                            RentalTCUnits: [
                                              // select a unit as default
                                              (
                                                ((
                                                  this.state.contractData.list.filter(
                                                    (tc) =>
                                                      tc.TCID === contract.TCID
                                                  )[0] || {}
                                                ).RentalTCUnits || [])[0] || {}
                                              ).UnitID,
                                            ].filter(Boolean),
                                          },
                                        });
                                      }}
                                    >
                                      Move Out
                                    </Menu.Item>
                                    {/* </Popconfirm> */}
                                  </Menu>
                                }
                                trigger={["hover"]}
                              >
                                <MoreOutlined style={{ fontSize: 18 }} />
                              </Dropdown>
                            </Col>
                          </Row>
                        }
                        style={{
                          width: "100%",
                          // height: "100px",
                          borderRadius: "30px",
                        }}
                        headStyle={{
                          textAlign: "center",
                          height: "30px",
                          minHeight: "30px",
                          // border: "0px",
                        }}
                        bodyStyle={{
                          padding: 20,
                          borderBottom: "0px solid",
                        }}
                      >
                        <Row>
                          <Col span={24}>
                            <h3>
                              Status:{" "}
                              <Tag color="cyan" style={{ borderRadius: 25 }}>
                                {contract.TCStatus}
                              </Tag>
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>
                              Contract No.:{" "}
                              <Tag color="green" style={{ borderRadius: 25 }}>
                                {contract.TCNo}
                              </Tag>
                            </h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Contract Date: {contract.TCDate}</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Valid From: {contract.TCFromDate}</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Valid Till: {contract.TCToDate}</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Email: {contract.TenantEmail || "N/A"}</h3>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <h3>Phone: {contract.TenantContactNo || "N/A"}</h3>
                          </Col>
                        </Row>
                        <Row gutter={[12, 12]}>
                          {(contract.RentalTCUnits || []).map(
                            (rtc, rtcIndex) => {
                              if (
                                (rtc.Unit || {}).UnitNo &&
                                (rtc.Unit.Building || {}).BuildingName
                              )
                                return (
                                  <Col
                                    span={12}
                                    style={{
                                      boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                                      transition: "0.3s",
                                      padding: 10,
                                    }}
                                  >
                                    <Row>
                                      <Col span={24}>
                                        <h3>
                                          Building:{" "}
                                          {rtc.Unit.Building.BuildingName}
                                        </h3>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col span={24}>
                                        <h3>Unit: {rtc.Unit.UnitNo}</h3>
                                      </Col>
                                    </Row>
                                  </Col>
                                );
                              return undefined;
                            }
                          )}
                        </Row>
                      </Card>
                    </Col>
                  );
                })}
          </Row>
          {/* {(this.state.mode === "All" || this.state.mode === "Cheque") &&
        this.state.chequeData.list.length ? (
          <Row>
            <Col span={24}>
              <Divider>
                <h3>Cheque</h3>
              </Divider>
            </Col>
          </Row>
        ) : null}
        <Row gutter={24}>
          {(this.state.mode === "All" || this.state.mode === "Cheque") &&
            this.state.chequeData.list.map((cheque, i, arr) => {
              return (
                <Col
                  key={i}
                  span={4}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 8 }}
                  style={{
                    marginTop: 2,
                    marginBottom: i === arr.length - 1 ? 0 : 18,
                  }}
                >
                  <Card
                    key={i}
                    title={"#" + (i + 1)}
                    style={{
                      width: "100%",
                      // height: "100px",
                      borderRadius: "30px",
                    }}
                    headStyle={{
                      textAlign: "center",
                      height: "30px",
                      minHeight: "30px",
                      // border: "0px",
                    }}
                    bodyStyle={{
                      padding: 20,
                      borderBottom: "0px solid",
                    }}
                  >
                    <Row>
                      <Col span={24}>
                        <h3>
                          Status:{" "}
                          <Tag color="cyan" style={{ borderRadius: 25 }}>
                            {this.pdc_status_map[cheque.PDC_Status]}
                          </Tag>
                        </h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <h3>
                          Cheque No.:{" "}
                          <Tag color="green">{cheque.Chq_Ref_No}</Tag>
                        </h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <h3>Cheque Date: {cheque.Chq_Ref_Dt}</h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <h3>Is PDC: {cheque.Is_PDC ? "Yes" : "No"}</h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <h3>Amount: {cheque.TR_CURR_AMT}</h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24} style={{ textAlign: "center" }}></Col>
                    </Row>
                  </Card>
                </Col>
              );
            })}
        </Row> */}
          {this.state.mode === "All" ? (
            !this.state.contractData.list.length &&
            !this.state.complaintData.list.length &&
            !this.state.chequeData.list.length ? (
              <Row gutter={24}>
                <Col span={24}>
                  <Empty />
                </Col>
              </Row>
            ) : null
          ) : this.state.mode === "Contract" ? (
            !this.state.contractData.list.length ? (
              <Row gutter={24}>
                <Col span={24}>
                  <Empty />
                </Col>
              </Row>
            ) : null
          ) : this.state.mode === "Complaint" ? (
            !this.state.complaintData.list.length ? (
              <Row gutter={24}>
                <Col span={24}>
                  <Empty />
                </Col>
              </Row>
            ) : null
          ) : this.state.mode === "Cheque" ? (
            !this.state.chequeData.list.length ? (
              <Row gutter={24}>
                <Col span={24}>
                  <Empty />
                </Col>
              </Row>
            ) : null
          ) : null}
        </Spin>
        <Modal
          visible={this.state.modalIsVisible}
          title={
            <>
              Complaint
              {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span>
                <Switch
                  // disabled={this.state.complaint.OpenClosed === "Closed"}
                  checkedChildren="Open"
                  unCheckedChildren="Closed"
                  checked={
                    this.state.complaint.OpenClosed === "Open" ? true : false
                  }
                  onChange={(checked) => {
                    let state = this.state;
                    state.complaint.OpenClosed = checked ? "Open" : "Closed";
                    this.setState(state);
                  }}
                ></Switch>
              </span> */}
            </>
          }
          bodyStyle={{
            padding: 10,
          }}
          centered
          style={{
            maxHeight: window.innerHeight - 150,
            overflowY: "auto",
          }}
          okText={this.state.complaint.ComplaintID ? "Update" : "Create"}
          okButtonProps={{
            disabled: this.state.dataBeingSaved,
            icon: this.state.dataBeingSaved ? <LoadingOutlined /> : null,
            style: {
              borderRadius: 20,
              // display:
              //   (
              //     this.state.complaintData.list.filter(
              //       (complaint) =>
              //         complaint.ComplaintID === this.state.complaint.ComplaintID
              //     )[0] || {}
              //   ).OpenClosed === "Closed"
              //     ? "none"
              //     : undefined,
            },
          }}
          cancelButtonProps={{
            style: {
              borderRadius: 20,
              // display:
              //   (
              //     this.state.complaintData.list.filter(
              //       (complaint) =>
              //         complaint.ComplaintID === this.state.complaint.ComplaintID
              //     )[0] || {}
              //   ).OpenClosed === "Closed"
              //     ? "none"
              //     : undefined,
            },
          }}
          onOk={() => {
            this.setState({
              dataBeingSaved: true,
            });
            /**
             * make the complaint created/udpated
             * by the tenant, always not viewed
             * (i.e. Viewed:false) so
             * that it would be notifiable to an
             * employee.
             */
            (this.state.complaint.ComplaintID
              ? axiosInstance.put(complaint, {
                  ...this.state.complaint,
                  DateEdited: new Date().toISOString().split("T")[0],
                })
              : axiosInstance.post(complaint, {
                  ...this.state.complaint,
                  Viewed: false,
                })
            )
              .then((res) => {
                if (res.data.success) {
                  axiosInstance
                    .get(complaintURL + "?ComplaintID=" + res.data.message)
                    .then((res) => {
                      if (res.data.success)
                        this.uploadAttachments(
                          res.data.message.rows[0].ComplaintID
                        ).then(() => {
                          this.getInitialState().then((st) =>
                            this.setState({
                              ...st,
                              complaint: {
                                ...st.complaint,
                                ComplaintID:
                                  res.data.message.rows[0].ComplaintID,
                              },
                            })
                          );
                        });
                    })
                    .catch(() => {
                      this.setState({ dataIsLoading: false });
                    });
                  notification.success({
                    message: "Success",
                    description: "Done!",
                  });
                } else
                  notification.error({
                    message: "Fail",
                    description: res.data.message || "Something went wrong!",
                  });
                this.setState({
                  dataBeingSaved: false,
                });
              })
              .catch((err) => {
                this.setState({
                  dataBeingSaved: false,
                });
              });
          }}
          onCancel={() => {
            this.getInitialState().then((st) => this.setState(st));
          }}
          width={window.innerWidth - 40 > 400 ? 400 : window.innerWidth - 40}
        >
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="Detail" key="1">
              <Row>
                <Col
                  span={6}
                  xs={{ span: 8 }}
                  sm={{ span: 8 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                >
                  <label>Building</label>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 16 }}
                  sm={{ span: 16 }}
                  md={{ span: 16 }}
                  lg={{ span: 16 }}
                >
                  <Select
                    disabled={this.state.complaint.OpenClosed === "Closed"}
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select a building"
                    optionFilterProp="children"
                    onChange={(val) => {
                      let state = this.state;
                      state.complaint.BuildingID = val;
                      for (let building of state.buildingData.list)
                        if (building.BuildingID === val) {
                          state.complaint.LegalCompany_ID =
                            building.LegalCompany_ID;
                          state.complaint.Division_ID = building.Division_ID;
                          state.complaint.ProjectID = building.ProjectID;
                          state.unitData.list = building.units;
                          state.complaint.UnitID = null;
                          break;
                        }
                      this.setState(state);
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    value={this.state.complaint.BuildingID}
                  >
                    {this.state.buildingData.list.map((building, index) => {
                      return (
                        <Select.Option key={index} value={building.BuildingID}>
                          {building.BuildingName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col
                  span={6}
                  xs={{ span: 8 }}
                  sm={{ span: 8 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                >
                  <label>Unit</label>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 16 }}
                  sm={{ span: 16 }}
                  md={{ span: 16 }}
                  lg={{ span: 16 }}
                >
                  <Select
                    disabled={this.state.complaint.OpenClosed === "Closed"}
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select a unit"
                    optionFilterProp="children"
                    onChange={(val) => {
                      let state = this.state;
                      state.complaint.UnitID = val;
                      for (let unit of state.unitData.list)
                        if (unit.UnitID === val) {
                          state.complaint.TCID = unit.TCID;
                          break;
                        }
                      this.setState(state);
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    value={this.state.complaint.UnitID}
                  >
                    {this.state.unitData.list.map((unit, index) => {
                      return (
                        <Select.Option key={index} value={unit.UnitID}>
                          {unit.UnitNo}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col
                  span={6}
                  xs={{ span: 8 }}
                  sm={{ span: 8 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                >
                  <label>Complaint Type</label>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 16 }}
                  sm={{ span: 16 }}
                  md={{ span: 16 }}
                  lg={{ span: 16 }}
                >
                  <Select
                    disabled={this.state.complaint.OpenClosed === "Closed"}
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select a type"
                    optionFilterProp="children"
                    onChange={(val) => {
                      let state = this.state;
                      state.complaint.ComplaintTypeID = val;
                      state.complaint.ComplaintDetails[0].ComplaintTypeID = val;
                      this.setState(state);
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    value={this.state.complaint.ComplaintTypeID}
                  >
                    {this.state.complaintTypeData.list.map((type, index) => {
                      return (
                        <Select.Option key={index} value={type.ComplaintTypeID}>
                          {type.UserName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col
                  span={6}
                  xs={{ span: 8 }}
                  sm={{ span: 8 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                >
                  <label>Description</label>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 16 }}
                  sm={{ span: 16 }}
                  md={{ span: 16 }}
                  lg={{ span: 16 }}
                >
                  <Input.TextArea
                    disabled={this.state.complaint.OpenClosed === "Closed"}
                    placeholder="Oh no! What's wrong?"
                    onChange={(e) => {
                      let state = this.state;
                      state.complaint.Remarks = e.target.value;
                      state.complaint.ComplaintDetails[0].Description =
                        e.target.value;
                      this.setState(state);
                    }}
                    value={this.state.complaint.Remarks}
                  ></Input.TextArea>
                </Col>
              </Row>
              {this.state.complaint.OpenClosed === "Closed" ? (
                <>
                  <Row>
                    <Col span={24}>
                      <Divider style={{ marginBottom: 10 }}></Divider>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col
                      span={6}
                      xs={{ span: 8 }}
                      sm={{ span: 8 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                    >
                      <label>Feedback</label>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 16 }}
                      sm={{ span: 16 }}
                      md={{ span: 16 }}
                      lg={{ span: 16 }}
                    >
                      <span style={{ width: "100%" }}>
                        <Rate
                          style={{ width: "100%", color: "green" }}
                          tooltips={this.state.feedbackRate.list}
                          onChange={(value) => {
                            let state = this.state;
                            state.complaint.TenantFeedback =
                              this.state.feedbackRate.list[value - 1];
                            state.complaint.FeedbackPoints = value;
                            this.setState(state);
                          }}
                          value={this.state.complaint.FeedbackPoints}
                          character={({ index }) =>
                            this.state.feedbackRate.customIcons[index + 1]
                          }
                        />
                      </span>
                    </Col>
                  </Row>
                  <Row gutter={8} style={{ marginTop: 10 }}>
                    <Col
                      span={6}
                      xs={{ span: 8 }}
                      sm={{ span: 8 }}
                      md={{ span: 8 }}
                      lg={{ span: 8 }}
                    >
                      <label>Remarks</label>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 16 }}
                      sm={{ span: 16 }}
                      md={{ span: 16 }}
                      lg={{ span: 16 }}
                    >
                      <Input.TextArea
                        placeholder="Any suggestions?"
                        onChange={(e) => {
                          let state = this.state;
                          state.complaint.Feedback = e.target.value;
                          this.setState(state);
                        }}
                        value={this.state.complaint.Feedback}
                      ></Input.TextArea>
                    </Col>
                  </Row>
                </>
              ) : undefined}
              {/* <Row gutter={8} style={{ marginTop: 10 }}>
            <Col
              span={6}
              xs={{ span: 8 }}
              sm={{ span: 8 }}
              md={{ span: 8 }}
              lg={{ span: 8 }}
            >
              <label>Solution</label>
            </Col>
            <Col
              span={6}
              xs={{ span: 16 }}
              sm={{ span: 16 }}
              md={{ span: 16 }}
              lg={{ span: 16 }}
            >
              <Input.TextArea
                placeholder="Wanna suggest solution(s)?"
                onChange={(e) => {
                  let state = this.state;
                  state.complaint.SolutionDescription = e.target.value;
                  this.setState(state);
                }}
                value={this.state.complaint.SolutionDescription}
              ></Input.TextArea>
            </Col>
          </Row> */}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Attachment" key="2">
              <Row>
                <Col span={24}>
                  <Divider orientation="center" style={{ fontSize: 14 }}>
                    Attachments&nbsp;&nbsp;
                    <Upload
                      style={{
                        width: "100%",
                        maxHeight: 150,
                        textAlign: "right",
                      }}
                      onRemove={(file) => {
                        file.originalName = file.originalName || file.name;
                        this.setState((state) => {
                          const index = state.attachmentList.indexOf(file);
                          const newFileList = state.attachmentList.slice();
                          newFileList.splice(index, 1);
                          return {
                            attachmentList: newFileList,
                          };
                        });
                      }}
                      beforeUpload={(file) => {
                        file.originalName = file.originalName || file.name;
                        if (
                          this.state.attachmentList.slice(0, 1).reduce(
                            (prev, curr) => ({
                              size: prev.size + curr.size,
                            }),
                            { size: 0 }
                          ).size +
                            file.size >
                          10485760
                        )
                          return message.error(
                            "Total combined file size cannot be greater than 10MB !"
                          );
                        let filereader = new FileReader();
                        filereader.onloadend = () => {
                          let state = this.state;
                          state.attachmentList = [
                            ...state.attachmentList.slice(0, 4),
                            file,
                          ];
                          this.setState(state);
                        };
                        filereader.readAsDataURL(file);
                        return false;
                      }}
                      multiple
                      maxCount={2}
                      accept=".jpg,.jpeg"
                      fileList={this.state.attachmentList}
                    >
                      <Tooltip
                        title="Click to upload new file(s). Max files: 2, Max size: 10MB, Types: JPEG, JPG"
                        defaultVisible
                      >
                        <UploadOutlined style={{ color: "#1890ff" }} />
                      </Tooltip>
                    </Upload>
                  </Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={24}
                  style={{
                    height: 250,
                    overflowY: "scroll",
                    overflowX: "hidden",
                  }}
                >
                  {this.state.complaint.ComplaintAttachments.length ? (
                    <Row gutter={8}>
                      {this.state.complaint.ComplaintAttachments.map(
                        (attachment) => {
                          switch (attachment.Doc_Ext.toLowerCase()) {
                            case "jpg":
                            case "jpeg":
                            case "png":
                              return (
                                <Col
                                  span={8}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 12 }}
                                  lg={{ span: 12 }}
                                  style={{ marginTop: 10 }}
                                >
                                  <Row>
                                    {(
                                      this.state.complaintData.list.filter(
                                        (complaint) =>
                                          complaint.ComplaintID ===
                                          this.state.complaint.ComplaintID
                                      )[0] || {}
                                    ).OpenClosed === "Open" ? (
                                      <Col
                                        span={24}
                                        style={{ textAlign: "right" }}
                                      >
                                        <Popconfirm
                                          title="Are you sure to delete this attachment?"
                                          onConfirm={() =>
                                            this.deleteAttachment(
                                              attachment.AutoNo
                                            )
                                          }
                                        >
                                          <DeleteOutlined
                                            style={{ color: "red" }}
                                          />
                                        </Popconfirm>
                                      </Col>
                                    ) : undefined}
                                    <Col span={24}>
                                      <Tooltip
                                        title={
                                          "Filename: " +
                                          attachment.Doc_Name.split("-")
                                            .slice(4)
                                            .join("-")
                                        }
                                      >
                                        <Image
                                          width="100%"
                                          height={200}
                                          src={
                                            baseUrl +
                                            "/uploads?location=" +
                                            attachment.Doc_Name +
                                            "." +
                                            attachment.Doc_Ext +
                                            "&tj=" +
                                            generateToken()
                                          }
                                          fallback="data:image/png;base64,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"
                                        ></Image>
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            case "mp4":
                            case "webm":
                            case "ogg":
                              return (
                                <Col
                                  span={8}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 12 }}
                                  lg={{ span: 12 }}
                                  style={{ marginTop: 10 }}
                                >
                                  <Row>
                                    {(
                                      this.state.complaintData.list.filter(
                                        (complaint) =>
                                          complaint.ComplaintID ===
                                          this.state.complaint.ComplaintID
                                      )[0] || {}
                                    ).OpenClosed === "Closed" ? (
                                      <Col
                                        span={24}
                                        style={{ textAlign: "right" }}
                                      >
                                        <Popconfirm
                                          title="Are you sure to delete this attachment?"
                                          onConfirm={() =>
                                            this.deleteAttachment(
                                              attachment.AutoNo
                                            )
                                          }
                                        >
                                          <DeleteOutlined
                                            style={{ color: "red" }}
                                          />
                                        </Popconfirm>
                                      </Col>
                                    ) : undefined}
                                    <Col span={24}>
                                      <Tooltip
                                        title={
                                          "Filename: " +
                                          attachment.Doc_Name.split("-")
                                            .slice(4)
                                            .join("-")
                                        }
                                      >
                                        <video
                                          width="100%"
                                          height={200}
                                          controls
                                          src={
                                            baseUrl +
                                            "/uploads?location=" +
                                            attachment.Doc_Name +
                                            "." +
                                            attachment.Doc_Ext +
                                            "&tj=" +
                                            generateToken()
                                          }
                                        >
                                          Your browser does not support the
                                          video element.
                                        </video>
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            case "mp3":
                            case "wav":
                              return (
                                <Col
                                  span={8}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 12 }}
                                  lg={{ span: 12 }}
                                  style={{ marginTop: 10 }}
                                >
                                  <Row>
                                    {(
                                      this.state.complaintData.list.filter(
                                        (complaint) =>
                                          complaint.ComplaintID ===
                                          this.state.complaint.ComplaintID
                                      )[0] || {}
                                    ).OpenClosed === "Closed" ? (
                                      <Col
                                        span={24}
                                        style={{ textAlign: "right" }}
                                      >
                                        <Popconfirm
                                          title="Are you sure to delete this attachment?"
                                          onConfirm={() =>
                                            this.deleteAttachment(
                                              attachment.AutoNo
                                            )
                                          }
                                        >
                                          <DeleteOutlined
                                            style={{ color: "red" }}
                                          />
                                        </Popconfirm>
                                      </Col>
                                    ) : undefined}
                                    <Col span={24}>
                                      <Tooltip
                                        title={
                                          "Filename: " +
                                          attachment.Doc_Name.split("-")
                                            .slice(4)
                                            .join("-")
                                        }
                                      >
                                        <audio
                                          width="100%"
                                          height={200}
                                          controls
                                          src={
                                            baseUrl +
                                            "/uploads?location=" +
                                            attachment.Doc_Name +
                                            "." +
                                            attachment.Doc_Ext +
                                            "&tj=" +
                                            generateToken()
                                          }
                                        >
                                          Your browser does not support the
                                          audio element.
                                        </audio>
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            default:
                              return (
                                <Col
                                  span={8}
                                  xs={{ span: 24 }}
                                  sm={{ span: 24 }}
                                  md={{ span: 12 }}
                                  lg={{ span: 12 }}
                                  style={{
                                    textAlign: "center",
                                    marginTop: 10,
                                  }}
                                >
                                  <Row>
                                    {(
                                      this.state.complaintData.list.filter(
                                        (complaint) =>
                                          complaint.ComplaintID ===
                                          this.state.complaint.ComplaintID
                                      )[0] || {}
                                    ).OpenClosed === "Closed" ? (
                                      <Col
                                        span={24}
                                        style={{ textAlign: "right" }}
                                      >
                                        <Popconfirm
                                          title="Are you sure to delete this attachment?"
                                          onConfirm={() =>
                                            this.deleteAttachment(
                                              attachment.AutoNo
                                            )
                                          }
                                        >
                                          <DeleteOutlined
                                            style={{ color: "red" }}
                                          />
                                        </Popconfirm>
                                      </Col>
                                    ) : undefined}
                                    <Col span={24}>
                                      <Tooltip
                                        title={
                                          "Filename: " +
                                          attachment.Doc_Name.split("-")
                                            .slice(4)
                                            .join("-")
                                        }
                                      >
                                        <div
                                          key={"div" + attachment.AutoNo}
                                          style={{
                                            position: "relative",
                                            textAlign: "center",
                                          }}
                                        >
                                          <FileOutlined
                                            style={{ fontSize: "200px" }}
                                            onClick={() => {
                                              let a =
                                                document.createElement("a");
                                              a.href =
                                                baseUrl +
                                                "/uploads?location=" +
                                                attachment.Doc_Name +
                                                "." +
                                                attachment.Doc_Ext +
                                                "&tj=" +
                                                generateToken();
                                              a.target = "_blank";
                                              a.download =
                                                attachment.Doc_Name.split("-")
                                                  .slice(4)
                                                  .join("-");
                                              a.click();
                                            }}
                                          />
                                          <label
                                            key={"label" + attachment.AutoNo}
                                            style={{
                                              position: "absolute",
                                              top: "50%",
                                              left: "50%",
                                              transform:
                                                "translate(-50%, -50%)",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {attachment.Doc_Type}
                                          </label>
                                        </div>
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                          }
                        }
                      )}
                    </Row>
                  ) : (
                    <Row>
                      <Col span={4}></Col>
                      <Col span={16}>
                        <Empty />
                      </Col>
                      <Col span={4}></Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Tabs.TabPane>
          </Tabs>
        </Modal>
        <Modal
          visible={this.state.moveoutModalIsVisible}
          title={<>Move out</>}
          bodyStyle={{
            padding: 10,
          }}
          centered
          style={{
            maxHeight: window.innerHeight - 150,
            overflowY: "hidden",
          }}
          okText={"Create"}
          okButtonProps={{
            disabled: this.state.dataBeingSaved,
            icon: this.state.dataBeingSaved ? <LoadingOutlined /> : null,
            style: {
              borderRadius: 20,
            },
          }}
          cancelButtonProps={{
            style: {
              borderRadius: 20,
            },
          }}
          onOk={() => {
            this.setState({
              dataBeingSaved: true,
            });
            axiosInstance
              .post(unitHandoverVacating, {
                ...this.state.handoverVacating,
              })
              .then((res) => {
                if (res.data.success) {
                  notification.success({
                    message: "Success",
                    description: "Request created ! Generating permit...",
                  });
                  this.setState({
                    dataIsLoading: true,
                    dataBeingSaved: true,
                    moveoutModalIsVisible: false,
                    handoverVacating: {},
                  });
                  axiosInstance
                    .get(
                      unitHandoverVacating + "/report?CSRID=" + res.data.CSRID
                    )
                    .then((res) => {
                      this.setState({
                        handoverVacating: {},
                        dataIsLoading: false,
                        dataBeingSaved: false,
                      });
                      if ((res.data || {}).success === false) {
                        this.setState({
                          dataBeingSaved: false,
                        });
                        return notification.error({
                          message: "Fail",
                          description:
                            res.data.message || "Something went wrong !",
                        });
                      }
                      let element = document.createElement("a");
                      element.setAttribute(
                        "href",
                        unitHandoverVacating +
                          "/report?filename=" +
                          res.data.message +
                          "&token=" +
                          encodedToken.value
                      );
                      element.setAttribute("target", "_blank");
                      element.setAttribute("rel", "noopener noreferrer");
                      document.body.appendChild(element);
                      element.click();
                      document.body.removeChild(element);
                    });
                } else {
                  notification.error({
                    message: "Fail",
                    description: res.data.message || "Something went wrong!",
                  });
                  this.setState({
                    dataBeingSaved: false,
                    dataIsLoading: false,
                  });
                }
              })
              .catch((err) => {
                this.setState({
                  dataBeingSaved: false,
                  dataIsLoading: false,
                });
              });
          }}
          onCancel={() => {
            this.setState({
              handoverVacating: {},
              dataIsLoading: false,
              dataBeingSaved: false,
              moveoutModalIsVisible: false,
            });
          }}
          width={window.innerWidth - 40 > 400 ? 400 : window.innerWidth - 40}
        >
          <>
            <Row style={{ marginTop: 10 }}>
              <Col
                span={6}
                xs={{ span: 8 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 8 }}
              >
                <label>Unit</label>
              </Col>
              <Col
                span={6}
                xs={{ span: 16 }}
                sm={{ span: 16 }}
                md={{ span: 16 }}
                lg={{ span: 16 }}
              >
                <Select
                  disabled={this.state.complaint.OpenClosed === "Closed"}
                  showSearch
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Select a unit"
                  optionFilterProp="children"
                  onChange={(unitID) => {
                    let state = this.state;
                    if (!state.handoverVacating.RentalTCUnits)
                      state.handoverVacating.RentalTCUnits = [];
                    state.handoverVacating.RentalTCUnits = unitID;
                    this.setState(state);
                  }}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  value={this.state.handoverVacating.RentalTCUnits}
                >
                  {(
                    (
                      this.state.contractData.list.filter(
                        (tc) => tc.TCID === this.state.moveoutModalIsVisible
                      )[0] || {}
                    ).RentalTCUnits || []
                  ).map((rtc, index) => {
                    if ((rtc.Unit || {}).UnitNo)
                      return (
                        <Select.Option key={index} value={rtc.UnitID}>
                          {rtc.Unit.UnitNo}
                        </Select.Option>
                      );
                    return null;
                  })}
                </Select>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col
                span={6}
                xs={{ span: 8 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 8 }}
              >
                <label>Vacating Date</label>
              </Col>
              <Col
                span={6}
                xs={{ span: 16 }}
                sm={{ span: 16 }}
                md={{ span: 16 }}
                lg={{ span: 16 }}
              >
                <DatePicker
                  format={this.state.dateFormat + " " + this.state.timeFormat}
                  allowClear={false}
                  style={{
                    width: "100%",
                  }}
                  showTime
                  disabledDate={(current) => {
                    let validDateRange = [
                      moment(),
                      moment(
                        new Date(
                          (
                            this.state.contractData.list.filter(
                              (tc) =>
                                tc.TCID === this.state.moveoutModalIsVisible
                            )[0] || {}
                          ).TCToDate
                        )
                      ),
                    ];
                    return (
                      current &&
                      (current < moment(new Date(validDateRange[0])) ||
                        current >
                          moment(new Date(validDateRange[1])).endOf("day"))
                    );
                  }}
                  onChange={(val) => {
                    let state = this.state;
                    state.handoverVacating.VacatingDate = val;
                    this.setState(state);
                  }}
                  value={this.state.handoverVacating.VacatingDate}
                ></DatePicker>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col
                span={6}
                xs={{ span: 8 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 8 }}
              >
                <label>Description</label>
              </Col>
              <Col
                span={6}
                xs={{ span: 16 }}
                sm={{ span: 16 }}
                md={{ span: 16 }}
                lg={{ span: 16 }}
              >
                <Input.TextArea
                  placeholder="Any reason, feedback ?"
                  onChange={(e) => {
                    let state = this.state;
                    state.handoverVacating.Remarks = e.target.value;
                    this.setState(state);
                  }}
                  value={this.state.handoverVacating.Remarks}
                ></Input.TextArea>
              </Col>
            </Row>
          </>
        </Modal>
        <BackTop
          style={{
            height: 40,
            width: 40,
            lineHeight: "40px",
            borderRadius: 20,
            borderWidth: 5,
            backgroundColor: "#001529",
            color: "white",
            textAlign: "center",
            fontSize: 14,
          }}
          target={() => document.getElementById("theBody")}
        >
          <div>
            <ArrowUpOutlined />
          </div>
        </BackTop>
      </div>
    );
  }
}

export default withRouter(TenantHome);
